import { Pipe, PipeTransform } from '@angular/core';

import { Origem } from '../domain';

@Pipe({
    name: 'origemIcon'
})
export class OrigemIconPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const origem = Origem.getById(value);
        return origem ? origem.icon : '';
    }
}
